<template>
<b-select id="selector" x-icon="credit-card" v-model="priceCurrency" size="is-small">
  <option v-for="info,name in currencies" :value="name"><span v-html="info.symbol"/> {{name}}</option>
</b-select>
</template>

<script>
import PriceTable from '../pricer.js'
import Pricer from '../pricer.js'

export default {
  name: 'CurrencySelector',
  data: function() { return {
    currencies: PriceTable.Currencies,
  }},
  computed: {
    priceCurrency: {
      get: function() { return this.currencies[this.$store.state.currency] ? this.$store.state.currency : 'USD' },
      set: function(v) { return this.$store.commit('updateCurrency', v) }
    }
  },
}
</script>

    



// WEBPACK FOOTER //
// src/components/CurrencySelector.vue